import { Field, Input, Stack } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/withTranslate"

const LicenseGroupName = ({ value, onChange, errors }) => {
  const tPrefix = "resource.licensing_form.group_name"
  const { t } = useTranslate()

  return (
    <Field.Root invalid={errors.length > 0} size="lg">
      <Stack>
        <Field.Label>{t(`${tPrefix}.title`)}</Field.Label>
        <Field.HelperText>{t(`${tPrefix}.body`)}</Field.HelperText>
      </Stack>

      <Input
        variant="subtle"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        borderRadius="40px"
        autoFocus
      />
      {errors.map((error) => (
        <Field.ErrorText key={error}>{error}</Field.ErrorText>
      ))}
    </Field.Root>
  )
}

LicenseGroupName.displayName = "LicenseGroupName"

export default LicenseGroupName
